module.exports = __webpack_public_path__ + "img/c_6.f003aca4.png";